import {
  Component,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  HostListener
} from '@angular/core';

@Component({
  selector: 'app-video-device-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})

export class VideoPlayerComponent implements AfterViewInit, OnChanges {

  @Input() stream!: MediaStream | null;
  @Input() deviceName: string = '';
  @Input() isActive: boolean = false;

  @Output() playerClick = new EventEmitter<void>();
  @Output() fullscreenToggle = new EventEmitter<boolean>();
  @Output() pipToggle = new EventEmitter<boolean>();

  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;

  showControls = false;
  hideTimeout: any;

  isMuted = true;
  volume = 1;
  isFullscreen = false;
  isPiP = false;

  ngAfterViewInit(): void {
    this.attachStream();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['stream']) {
      this.attachStream();
    }
  }

  private async attachStream(): Promise<void> {
  if (!this.videoElement || !this.stream) {
    return;
  }

  const video = this.videoElement.nativeElement;

  // Set these before srcObject/play
  video.muted = true;
  video.defaultMuted = true;
  video.autoplay = true;
  video.playsInline = true;

  video.srcObject = this.stream;

  try {
    await video.play();
  } catch (e) {
    console.error('play blocked:', e);
  }
}

  // 👆 Interaction
  onPlayerClick(): void {
    this.playerClick.emit();
  }

  // 🖱 Auto-show controls
  @HostListener('mousemove')
  onMouseMove() {
    this.showControls = true;

    clearTimeout(this.hideTimeout);
    this.hideTimeout = setTimeout(() => {
      this.showControls = false;
    }, 2000);
  }

  // 🔊 Audio
  toggleMute(): void {
    this.isMuted = !this.isMuted;
    this.videoElement.nativeElement.muted = this.isMuted;
  }

  setVolume(event: any): void {
    this.volume = event.target.value;
    this.videoElement.nativeElement.volume = this.volume;
  }

  // ⛶ Fullscreen
  toggleFullscreen(): void {
    const container = this.videoElement.nativeElement.parentElement;

    if (!this.isFullscreen) {
      container?.requestFullscreen();
    } else {
      document.exitFullscreen();
    }

    this.isFullscreen = !this.isFullscreen;
    this.fullscreenToggle.emit(this.isFullscreen);
  }

  // 📺 PiP
  async togglePiP(): Promise<void> {
    const video = this.videoElement.nativeElement;

    if (document.pictureInPictureElement) {
      await document.exitPictureInPicture();
      this.isPiP = false;
    } else {
      await video.requestPictureInPicture();
      this.isPiP = true;
    }

    this.pipToggle.emit(this.isPiP);
  }
}
